import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  hashCodeq5arwsb9dgti as hashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  awaitqeg6zusi9ora as await_0,
  await1kke5zj2piplv as await_1,
} from '../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import {
  ButtonFormatting3voagp9s33g1x as ButtonFormatting,
  ButtonActionqmmxsu493eh2 as ButtonAction,
  applyReactiveActionFormatting11beyf0tv05i4 as applyReactiveActionFormatting,
} from '../../utils/ButtonAction.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { BaseTextInputDialog2ylbln5rtv3j3 as BaseTextInputDialog } from './TextInputDialog.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { lens3m3nj3zkwtu6r as lens } from '../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import {
  title1ahgushtajx2d as title,
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  SmallBodySemantic_getInstance13vsg4635cu56 as SmallBodySemantic_getInstance,
} from '../theming/Titles.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  get_centered1xfu6or5nc0lq as get_centered,
  get_expanding10cuv3ua9vajx as get_expanding,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { Button263cw152yl80e as Button } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import {
  Companion_instance357q0zxkn8vu9 as Companion_instance,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
  MonetaryValue__toString_impl_xslc771noy15rjps4pw as MonetaryValue__toString_impl_xslc77,
  MonetaryValue__plus_impl_c1ylt2px1svctotw0g as MonetaryValue__plus_impl_c1ylt,
} from '../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import {
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { listOfNotNull1v4ggfackvuny as listOfNotNull } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  plus310ted5e4i90h as plus,
  sortedWith2csnbbb21k0lg as sortedWith,
  joinToString1cxrrlmo0chqs as joinToString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import { PendingLineItem7uj25viy3ie8 as PendingLineItem } from '../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { ChangeRequestItemWrapperlr7b47p0t9ty as ChangeRequestItemWrapper } from '../components/project/work/changeOrders/data.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import { trimIndent1qytc1wvt8suh as trimIndent } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Indent.mjs';
import { DangerButtonSemantic_getInstanceb7gofax87736 as DangerButtonSemantic_getInstance } from '../theming/buttons.mjs';
import { get_dialogStackleaqvayyucjw as get_dialogStack } from '../components/nav/crowpay.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { denySelectedItems3azjke2mb2k1b as denySelectedItems } from '../components/project/work/changeOrders/approval.mjs';
import { ViewWriter2xfqkrnuqv5cx as ViewWriter } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/ViewWriter.mjs';
import { get_session9cytjmfbg8nd as get_session } from '../../sdk/UserSession.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $this$ButtonAction, $completion) {
  var tmp = $this.oig_1.iia($this.pig_1, true, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var SubmissionClass;
function Submission() {
  if (SubmissionClass === VOID) {
    class $ {
      constructor(item, message) {
        this.gih_1 = item;
        this.hih_1 = message;
      }
      toString() {
        return 'Submission(item=' + toString(this.gih_1) + ', message=' + this.hih_1 + ')';
      }
      hashCode() {
        var result = this.gih_1 == null ? 0 : hashCode(this.gih_1);
        result = imul(result, 31) + getStringHashCode(this.hih_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Submission()))
          return false;
        if (!equals(this.gih_1, other.gih_1))
          return false;
        if (!(this.hih_1 === other.hih_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Submission');
    SubmissionClass = $;
  }
  return SubmissionClass;
}
var WorkingClass;
function Working() {
  if (WorkingClass === VOID) {
    class $ {
      constructor(item, message) {
        message = message === VOID ? Signal().hak('') : message;
        this.iih_1 = item;
        this.jih_1 = message;
      }
      toString() {
        return 'Working(item=' + toString(this.iih_1) + ', message=' + toString_0(this.jih_1) + ')';
      }
      hashCode() {
        var result = this.iih_1 == null ? 0 : hashCode(this.iih_1);
        result = imul(result, 31) + hashCode(this.jih_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Working()))
          return false;
        if (!equals(this.iih_1, other.iih_1))
          return false;
        if (!equals(this.jih_1, other.jih_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Working');
    WorkingClass = $;
  }
  return WorkingClass;
}
function *_generator_submit__rtm368($this, _this__u8e3s4, confirmed, $completion) {
  if (confirmed) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $this.fih_1;
    var tmp = await_0(this_0, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var tmp$ret$0 = tmp;
    var tmp_0 = $this.cih_1(_this__u8e3s4, new (Submission())(tmp$ret$0.iih_1, $this.sgs_1.f2()), $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  }
  var tmp_1;
  if (confirmed) {
    var containsUpper = $this.dih_1.p1() - 1 | 0;
    var containsArg = $this.eih_1.f2() + 1 | 0;
    tmp_1 = 0 <= containsArg ? containsArg <= containsUpper : false;
  } else {
    tmp_1 = false;
  }
  if (tmp_1) {
    $this.sgs_1.oam('');
    var _receiver__tnumb7 = $this.eih_1;
    var _unary__edvuaz = _receiver__tnumb7.f2();
    _receiver__tnumb7.oam(_unary__edvuaz + 1 | 0);
  } else {
    var tmp_2 = $this.cih_1(_this__u8e3s4, null, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
  }
  return Unit_instance;
}
function PagedTextInputDialog$_init_$lambda_a65u2j(_unused_var__etf5q3, last) {
  return ButtonFormatting(last ? 'Submit' : 'Next Item');
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_1(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_1(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_2(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_2(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
var PagedTextInputDialog$submitButton$lambda$slambdaClass;
function PagedTextInputDialog$submitButton$lambda$slambda() {
  if (PagedTextInputDialog$submitButton$lambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $$this$button) {
        this.oig_1 = this$0;
        this.pig_1 = $$this$button;
      }
      yah($this$ButtonAction, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$ButtonAction), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    PagedTextInputDialog$submitButton$lambda$slambdaClass = $;
  }
  return PagedTextInputDialog$submitButton$lambda$slambdaClass;
}
function PagedTextInputDialog$submitButton$lambda$slambda_0(this$0, $$this$button) {
  var i = new (PagedTextInputDialog$submitButton$lambda$slambda())(this$0, $$this$button);
  var l = ($this$ButtonAction, $completion) => i.yah($this$ButtonAction, $completion);
  l.$arity = 1;
  return l;
}
var PagedTextInputDialogClass;
function PagedTextInputDialog() {
  if (PagedTextInputDialogClass === VOID) {
    class $ extends BaseTextInputDialog() {
      constructor(startingItems, itemHeader, itemMessage, confirmationButton, dismissText, minChars, onSubmit) {
        var tmp;
        if (confirmationButton === VOID) {
          tmp = PagedTextInputDialog$_init_$lambda_a65u2j;
        } else {
          tmp = confirmationButton;
        }
        confirmationButton = tmp;
        dismissText = dismissText === VOID ? 'Go Back' : dismissText;
        minChars = minChars === VOID ? 35 : minChars;
        super('unused', 'unused', 'unused', VOID, minChars, VOID, dismissText);
        this.zig_1 = itemHeader;
        this.aih_1 = itemMessage;
        this.bih_1 = confirmationButton;
        this.cih_1 = onSubmit;
        var tmp_0 = this;
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().u(collectionSizeOrDefault(startingItems, 10));
        var _iterator__ex2g4s = startingItems.m1();
        while (_iterator__ex2g4s.n1()) {
          var item = _iterator__ex2g4s.o1();
          var tmp$ret$0 = new (Working())(item);
          destination.v(tmp$ret$0);
        }
        tmp_0.dih_1 = destination;
        this.eih_1 = Signal().hak(0);
        var tmp_1 = this;
        tmp_1.fih_1 = lens(this.eih_1, (it) => this.dih_1.q1(it));
      }
      kia(_this__u8e3s4) {
        return title(_this__u8e3s4, ($this$title) => {
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl($this$title);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb($this$title));
          reactiveScope($this$title, ($this$reactiveScope) => {
            var tmp$ret$0 = this.zig_1($this$reactiveScope.daj(this.fih_1).iih_1);
            this_0.set(tmp$ret$0);
            return Unit_instance;
          });
          return Unit_instance;
        });
      }
      lia(_this__u8e3s4) {
        // Inline function 'com.crowpay.views.theming.body' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (TextView())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        view.lba(view.qb6_1.abf(BodySemantic_getInstance()));
        var tmp = KMutableProperty0();
        var tmp_0 = TextView$_get_content_$ref_4pzcwl_0(view);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_0(view));
        reactiveScope(view, ($this$reactiveScope) => {
          var tmp$ret$0 = this.aih_1($this$reactiveScope.daj(this.fih_1).iih_1);
          this_0.set(tmp$ret$0);
          return Unit_instance;
        });
        _this__u8e3s4.hbb(p, view);
        return view;
      }
      iia(_this__u8e3s4, confirmed, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_submit__rtm368.bind(VOID, this, _this__u8e3s4, confirmed), $completion);
      }
      oia(_this__u8e3s4) {
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        view.zbm(false);
        if (this.dih_1.p1() > 1) {
          var tmp = get_centered(view);
          // Inline function 'com.crowpay.views.theming.smallBody' call
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_0 = new (TextView())(view.pc());
          var tmp0_elvis_lhs_0 = view.ebb_1;
          var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
          view.gbb(p_0, view_0);
          view_0.lba(view_0.qb6_1.abf(SmallBodySemantic_getInstance()));
          var tmp_0 = KMutableProperty0();
          var tmp_1 = TextView$_get_content_$ref_4pzcwl_1(view_0);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_0 = getPropertyCallableRef('content', 0, tmp_0, tmp_1, TextView$_set_content_$ref_pketfb_1(view_0));
          reactiveScope(view_0, ($this$reactiveScope) => {
            var tmp$ret$0 = 'Item ' + ($this$reactiveScope.daj(this.eih_1) + 1 | 0) + ' / ' + this.dih_1.p1();
            this_0.set(tmp$ret$0);
            return Unit_instance;
          });
          view.hbb(p_0, view_0);
          view.lbb(tmp, view_0);
        }
        var tmp_2 = get_expanding(view);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (Space())(view.pc());
        var tmp0_elvis_lhs_1 = view.ebb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
        view.gbb(p_1, view_1);
        view.hbb(p_1, view_1);
        view.lbb(tmp_2, view_1);
        var tmp_3 = get_centered(view);
        // Inline function 'com.crowpay.views.theming.smallBody' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (TextView())(view.pc());
        var tmp0_elvis_lhs_2 = view.ebb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
        view.gbb(p_2, view_2);
        view_2.lba(view_2.qb6_1.abf(SmallBodySemantic_getInstance()));
        var tmp_4 = KMutableProperty0();
        var tmp_5 = TextView$_get_content_$ref_4pzcwl_2(view_2);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_1 = getPropertyCallableRef('content', 0, tmp_4, tmp_5, TextView$_set_content_$ref_pketfb_2(view_2));
        reactiveScope(view_2, ($this$reactiveScope) => {
          // Inline function 'kotlin.takeIf' call
          var this_0 = this.ogs_1 - $this$reactiveScope.daj(this.sgs_1).length | 0;
          var tmp;
          if (this_0 > 0) {
            tmp = this_0;
          } else {
            tmp = null;
          }
          var tmp0_safe_receiver = tmp;
          var tmp_0;
          if (tmp0_safe_receiver == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.let' call
            tmp_0 = '(' + tmp0_safe_receiver + ') more characters required';
          }
          var tmp1_elvis_lhs = tmp_0;
          var tmp$ret$14 = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
          this_1.set(tmp$ret$14);
          return Unit_instance;
        });
        view.hbb(p_2, view_2);
        view.lbb(tmp_3, view_2);
        _this__u8e3s4.hbb(p, view);
        return view;
      }
      jia(_this__u8e3s4) {
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (Button())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        var $this$button = view;
        var submit = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = this.bih_1($this$remember.daj(this.fih_1).iih_1, this.dih_1.p1() === 1);
          // Inline function 'kotlin.let' call
          var it = ButtonAction().pg1(tmp, PagedTextInputDialog$submitButton$lambda$slambda_0(this, $this$button));
          var tmp_0;
          if (this.ogs_1 > 0) {
            tmp_0 = it.rg1(VOID, VOID, VOID, VOID, VOID, ($this$copy) => $this$copy.daj(this.sgs_1).length >= this.ogs_1);
          } else {
            tmp_0 = it;
          }
          return tmp_0;
        });
        applyReactiveActionFormatting($this$button, submit);
        _this__u8e3s4.hbb(p, view);
        return view;
      }
    }
    initMetadataForClass($, 'PagedTextInputDialog', VOID, VOID, VOID, [2]);
    PagedTextInputDialogClass = $;
  }
  return PagedTextInputDialogClass;
}
function blurb(_this__u8e3s4, quotes) {
  quotes = quotes === VOID ? false : quotes;
  var tmp = blurb$name(_this__u8e3s4, quotes);
  var tmp_0 = _this__u8e3s4.b95().g95_1;
  var tmp0_elvis_lhs = _this__u8e3s4.w94();
  var tmp_1;
  var tmp_2 = tmp0_elvis_lhs;
  if ((tmp_2 == null ? null : new (MonetaryValue())(tmp_2)) == null) {
    tmp_1 = Companion_instance.m62(0);
  } else {
    tmp_1 = tmp0_elvis_lhs;
  }
  return tmp + ' (' + tmp_0 + ', ' + MonetaryValue__toString_impl_xslc77(tmp_1) + ')';
}
var SingleClass;
function Single() {
  if (SingleClass === VOID) {
    class $ extends MaybeLinked() {
      constructor(item) {
        super(blurb(item), item.y94());
        this.mih_1 = item;
      }
      toString() {
        return 'Single(item=' + toString_0(this.mih_1) + ')';
      }
      hashCode() {
        return hashCode(this.mih_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Single()))
          return false;
        if (!equals(this.mih_1, other.mih_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Single');
    SingleClass = $;
  }
  return SingleClass;
}
var LinkedClass;
function Linked() {
  if (LinkedClass === VOID) {
    class $ extends MaybeLinked() {
      constructor(linked) {
        // Inline function 'com.crowpay.extensions.sumMoney' call
        var sum = Companion_instance.r91(0n);
        var _iterator__ex2g4s = linked.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          var tmp = sum;
          var tmp0_elvis_lhs = element.w94();
          var tmp_0;
          var tmp_1 = tmp0_elvis_lhs;
          if ((tmp_1 == null ? null : new (MonetaryValue())(tmp_1)) == null) {
            tmp_0 = Companion_instance.r91(0n);
          } else {
            tmp_0 = tmp0_elvis_lhs;
          }
          var tmp$ret$0 = tmp_0;
          sum = MonetaryValue__plus_impl_c1ylt(tmp, tmp$ret$0);
        }
        var tmp$ret$1 = sum;
        var tmp_2 = 'Linked Items (' + MonetaryValue__toString_impl_xslc77(tmp$ret$1) + ')';
        // Inline function 'kotlin.collections.minOf' call
        var iterator = linked.m1();
        if (!iterator.n1())
          throw NoSuchElementException().y1();
        var minValue = iterator.o1().y94();
        while (iterator.n1()) {
          var v = iterator.o1().y94();
          if (compareTo(minValue, v) > 0) {
            minValue = v;
          }
        }
        super(tmp_2, minValue);
        this.pih_1 = linked;
      }
      toString() {
        return 'Linked(linked=' + toString_0(this.pih_1) + ')';
      }
      hashCode() {
        return hashCode(this.pih_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Linked()))
          return false;
        if (!equals(this.pih_1, other.pih_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Linked');
    LinkedClass = $;
  }
  return LinkedClass;
}
var MaybeLinkedClass;
function MaybeLinked() {
  if (MaybeLinkedClass === VOID) {
    class $ {
      constructor(name, itemNumber) {
        this.qih_1 = name;
        this.rih_1 = itemNumber;
      }
    }
    initMetadataForClass($, 'MaybeLinked');
    MaybeLinkedClass = $;
  }
  return MaybeLinkedClass;
}
function DenyChangeItemsDialog(items) {
  if (items.i1())
    throw IllegalArgumentException().a1('list cannot be empty');
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = items.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    if (element.u94()) {
      destination.v(element);
    }
  }
  // Inline function 'kotlin.takeIf' call
  var tmp;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!destination.i1()) {
    tmp = destination;
  } else {
    tmp = null;
  }
  var tmp0_safe_receiver = tmp;
  var tmp_0;
  if (tmp0_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_0 = new (Linked())(tmp0_safe_receiver);
  }
  var linked = tmp_0;
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList().w();
  var _iterator__ex2g4s_0 = items.m1();
  while (_iterator__ex2g4s_0.n1()) {
    var element_0 = _iterator__ex2g4s_0.o1();
    if (!element_0.u94()) {
      destination_0.v(element_0);
    }
  }
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList().u(collectionSizeOrDefault(destination_0, 10));
  var _iterator__ex2g4s_1 = destination_0.m1();
  while (_iterator__ex2g4s_1.n1()) {
    var item = _iterator__ex2g4s_1.o1();
    var tmp$ret$11 = new (Single())(item);
    destination_1.v(tmp$ret$11);
  }
  var individual = destination_1;
  // Inline function 'kotlin.collections.sortedBy' call
  var this_0 = plus(listOfNotNull(linked), individual);
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp_1 = DenyChangeItemsDialog$lambda;
  var tmp$ret$14 = new (sam$kotlin_Comparator$0())(tmp_1);
  var tmp1_startingItems = sortedWith(this_0, tmp$ret$14);
  var tmp_2 = DenyChangeItemsDialog$lambda_0;
  var tmp_3 = DenyChangeItemsDialog$lambda_1;
  var tmp_4 = DenyChangeItemsDialog$lambda_2;
  return new (PagedTextInputDialog())(tmp1_startingItems, tmp_2, tmp_3, tmp_4, 'Cancel', VOID, DenyChangeItemsDialog$slambda_0());
}
function WaitDrawsDialog(draws, onSubmit) {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = draws.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    if (!(element.uhc_1 == null)) {
      destination.v(element);
    }
  }
  var items = destination;
  if (items.i1())
    throw IllegalArgumentException().a1('Cannot have wait an empty list of pay app items');
  var tmp = WaitDrawsDialog$lambda;
  var tmp_0 = WaitDrawsDialog$lambda_0;
  var tmp_1 = WaitDrawsDialog$lambda_1;
  return new (PagedTextInputDialog())(items, tmp, tmp_0, tmp_1, 'Cancel', VOID, WaitDrawsDialog$slambda_0(onSubmit));
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.sih_1 = function_0;
      }
      wi(a, b) {
        return this.sih_1(a, b);
      }
      compare(a, b) {
        return this.wi(a, b);
      }
      i4() {
        return this.sih_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i4(), other.i4());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i4());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
function blurb$name(_this__u8e3s4, $quotes) {
  var tmp;
  if (_this__u8e3s4 instanceof ChangeRequestItemWrapper()) {
    tmp = blurb$name(_this__u8e3s4.ogp_1, $quotes);
  } else {
    if (_this__u8e3s4 instanceof PendingLineItem()) {
      tmp = $quotes ? '"' + _this__u8e3s4.w75_1 + '"' : _this__u8e3s4.w75_1;
    } else {
      tmp = 'Change ' + _this__u8e3s4.y94();
    }
  }
  return tmp;
}
function DenyChangeItemsDialog$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.rih_1;
  var tmp$ret$1 = b.rih_1;
  return compareValues(tmp, tmp$ret$1);
}
function DenyChangeItemsDialog$lambda_0(it) {
  return 'Deny ' + it.qih_1 + '?';
}
function DenyChangeItemsDialog$lambda_1(item) {
  var tmp;
  if (item instanceof Linked()) {
    var tmp_0 = item.pih_1.p1();
    tmp = trimIndent('\n                        Linked Items (' + tmp_0 + '):\n                        - ' + joinToString(item.pih_1, '\n- ', VOID, VOID, VOID, VOID, DenyChangeItemsDialog$lambda$lambda) + "\n                        \n                        Are you sure you want to deny these items? If you're sure, let the contractor know why below.\n                    ");
  } else {
    if (item instanceof Single()) {
      tmp = "Are you sure you want to deny this change? If you're sure, let the contractor know why below.";
    } else {
      noWhenBranchMatchedException();
    }
  }
  return tmp;
}
function DenyChangeItemsDialog$lambda$lambda(it) {
  return blurb(it);
}
function DenyChangeItemsDialog$lambda_2(_unused_var__etf5q3, _unused_var__etf5q3_0) {
  return ButtonFormatting('Deny', DangerButtonSemantic_getInstance());
}
function *_generator_invoke__zhh2q8_0($this, $this$PagedTextInputDialog, submission, $completion) {
  if (submission == null) {
    get_dialogStack().pgd();
    return Unit_instance;
  }
  var tmp0_subject = submission.gih_1;
  var tmp;
  if (tmp0_subject instanceof Linked()) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = submission.gih_1.pih_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.m1();
    while (_iterator__ex2g4s.n1()) {
      var item = _iterator__ex2g4s.o1();
      var tmp$ret$0 = to(item, submission.hih_1);
      destination.v(tmp$ret$0);
    }
    tmp = destination;
  } else {
    if (tmp0_subject instanceof Single()) {
      tmp = listOf(to(submission.gih_1.mih_1, submission.hih_1));
    } else {
      noWhenBranchMatchedException();
    }
  }
  var tmp_0 = denySelectedItems(tmp, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
var DenyChangeItemsDialog$slambdaClass;
function DenyChangeItemsDialog$slambda() {
  if (DenyChangeItemsDialog$slambdaClass === VOID) {
    class $ {
      tih($this$PagedTextInputDialog, submission, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$PagedTextInputDialog, submission), $completion);
      }
      rd(p1, p2, $completion) {
        var tmp = p1 instanceof ViewWriter() ? p1 : THROW_CCE();
        return this.tih(tmp, (p2 == null ? true : p2 instanceof Submission()) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    DenyChangeItemsDialog$slambdaClass = $;
  }
  return DenyChangeItemsDialog$slambdaClass;
}
function DenyChangeItemsDialog$slambda_0() {
  var i = new (DenyChangeItemsDialog$slambda())();
  var l = ($this$PagedTextInputDialog, submission, $completion) => i.tih($this$PagedTextInputDialog, submission, $completion);
  l.$arity = 2;
  return l;
}
function WaitDrawsDialog$lambda(it) {
  var tmp = it.i20();
  var tmp0_safe_receiver = it.uhc_1;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r6v_1;
  var tmp_0;
  var tmp_1 = tmp1_elvis_lhs;
  if ((tmp_1 == null ? null : new (MonetaryValue())(tmp_1)) == null) {
    tmp_0 = Companion_instance.r91(0n);
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  return 'Wait ' + tmp + ' (' + MonetaryValue__toString_impl_xslc77(tmp_0) + ')?';
}
function WaitDrawsDialog$lambda_0(it) {
  return "Are you sure you want to wait this draw? If you're sure, let the contractor know why below.";
}
function WaitDrawsDialog$lambda_1(_unused_var__etf5q3, _unused_var__etf5q3_0) {
  return ButtonFormatting('Wait', DangerButtonSemantic_getInstance());
}
function *_generator_invoke__zhh2q8_1($this, $this$PagedTextInputDialog, submission, $completion) {
  if (submission == null) {
    get_dialogStack().pgd();
    return Unit_instance;
  }
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_1(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.vfw().mfg_1;
  var tmp0_safe_receiver = submission.gih_1.uhc_1;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.o6v_1;
  var tmp_1;
  if (tmp1_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_1 = tmp1_elvis_lhs;
  }
  var tmp_2 = tmp_0.pfn(tmp_1, submission.hih_1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var tmp_3 = $this.uih_1(submission.gih_1.thc_1.mf9_1, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  return Unit_instance;
}
var WaitDrawsDialog$slambdaClass;
function WaitDrawsDialog$slambda() {
  if (WaitDrawsDialog$slambdaClass === VOID) {
    class $ {
      constructor($onSubmit) {
        this.uih_1 = $onSubmit;
      }
      vih($this$PagedTextInputDialog, submission, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, $this$PagedTextInputDialog, submission), $completion);
      }
      rd(p1, p2, $completion) {
        var tmp = p1 instanceof ViewWriter() ? p1 : THROW_CCE();
        return this.vih(tmp, (p2 == null ? true : p2 instanceof Submission()) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    WaitDrawsDialog$slambdaClass = $;
  }
  return WaitDrawsDialog$slambdaClass;
}
function WaitDrawsDialog$slambda_0($onSubmit) {
  var i = new (WaitDrawsDialog$slambda())($onSubmit);
  var l = ($this$PagedTextInputDialog, submission, $completion) => i.vih($this$PagedTextInputDialog, submission, $completion);
  l.$arity = 2;
  return l;
}
//region block: exports
export {
  DenyChangeItemsDialog as DenyChangeItemsDialog2gm5ndqwtjj7b,
  WaitDrawsDialog as WaitDrawsDialog11kr3h4lqhbji,
};
//endregion

//# sourceMappingURL=PagedUserTextInputDialog.mjs.map
